/*
 * @providesModule SkillzModule
 *
 */

import {NativeModules} from 'react-native';

const {SkillzModule: SkillzModuleNative} = NativeModules;
interface SkillzModuleInterface {
  reactSDKHasLoaded(): unknown;
  exitSkillz(): unknown;
  App: {
    Name: string;
    IconPath: string;
    GameId: string;
    GameHasSyncBot: boolean;
    IsLandscape: boolean;
    AppVersion: string;
    HasNotchedDisplay: boolean;
  };
  getRemoteNotificationPermission(completion: (status: string) => void): void;
  registerForRemoteNotifications(): void;
  setupNotificationsForDeniedPermissions(): void;
  setupNotificationsWithOptions: (
    modalTitle: string,
    modalBody: string,
    actionButtonTitle: string,
    cancelButtonTitle: string
  ) => void;
  playWinSound(): void;
  /**
   * Triggers playback of a sound file from the specified URL string.
   * - This method expects a valid URL string for an audio file in a format
   * supported by AVAudioPlayer (e.g., MP3, WAV, M4A). If the URL is invalid or the
   * download fails, an appropriate error message is logged.
   * - New audio files for testing can be added to the following path: 'sdk-mobile/sdk-core/js/source_images/soundFiles'
   * @param urlString The URL string pointing to the audio file (local or remote).
   */
  playSoundFromUri(uri: string): void;
  setEnabledKeyboardManager(enabled: boolean): void;
}
const SkillzModule: SkillzModuleInterface = SkillzModuleNative;

export default SkillzModule;
